<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M9.06208 3.75497V1.71415C9.06208 1.08296 8.5504 0.571289 7.91922 0.571289H1.71512C1.08394 0.571289 0.572266 1.08296 0.572266 1.71415V7.91825C0.572266 8.54943 1.08394 9.06111 1.71512 9.06111H3.75595"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.2869 6.93799H8.08231C7.45113 6.93799 6.93945 7.44966 6.93945 8.08085V14.2854C6.93945 14.9166 7.45113 15.4283 8.08231 15.4283H14.2869C14.9181 15.4283 15.4297 14.9166 15.4297 14.2854V8.08085C15.4297 7.44966 14.9181 6.93799 14.2869 6.93799Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.89118 12.7609C9.73339 12.7609 9.60547 12.633 9.60547 12.4752C9.60547 12.3173 9.73339 12.1895 9.89118 12.1895"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.89062 12.7609C10.0484 12.7609 10.1763 12.633 10.1763 12.4752C10.1763 12.3173 10.0484 12.1895 9.89062 12.1895"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.6822 4.00551C3.5244 4.00551 3.39648 3.87759 3.39648 3.7198C3.39648 3.562 3.5244 3.43408 3.6822 3.43408"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.68164 4.00551C3.83943 4.00551 3.96735 3.87759 3.96735 3.7198C3.96735 3.562 3.83943 3.43408 3.68164 3.43408"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.4791 10.4059C12.3214 10.4059 12.1934 10.278 12.1934 10.1202C12.1934 9.96239 12.3214 9.83447 12.4791 9.83447"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.4785 10.4059C12.6362 10.4059 12.7642 10.278 12.7642 10.1202C12.7642 9.96239 12.6362 9.83447 12.4785 9.83447"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
